import { ActionHandler } from "..";
import { getRecommendedHealthPlan } from "src/utils/health/planRecommendation";
import {
  MED_SKU,
  getEligibleMedProducts,
  getEligibleMedProductsPlanSelection,
} from "src/utils/medEligibility";
import { setHealthPlansInRecommendationContext } from "src/utils/redux/slices/recommendationContext";

/**
 * Action to determine and set the recommended plan for health route.
 */
export const loadRecommendedHealthPlan: ActionHandler = () => {
  const recommendedPlan = getRecommendedHealthPlan();

  if (!recommendedPlan) {
    return;
  }

  if (Object.values(MED_SKU).includes(recommendedPlan as any)) {
    const recommendedMedTier = recommendedPlan as MED_SKU;
    const eligibleMedProducts = getEligibleMedProducts();
    const eligibleMedTiers = getEligibleMedProductsPlanSelection(
      recommendedMedTier,
      eligibleMedProducts
    );

    setHealthPlansInRecommendationContext(
      recommendedPlan as MED_SKU, // recommendedHealthPlan (for all plans)
      recommendedMedTier, // recommendedMedTier (same value for med plans)
      eligibleMedTiers
    );
  } else {
    setHealthPlansInRecommendationContext(recommendedPlan);
  }
};
